import {
  Transcriptions,
  useVideoJSPlayerContext,
  NewPlayer
} from '@entertainment-ai/mansueto';
import React, { useEffect } from 'react';
import Title from '../../../../../components/eventsHub/atoms/text/Title';
import Eyebrow from '../../../../../components/eventsHub/atoms/text/Eyebrow';
import DescriptionText from '../../../../../components/eventsHub/atoms/text/DescriptionText';
import { getEyebrowFromTags } from '../../utils';

const VideoPlayer = ({ video }) => {
  const { seekTo, currentTime } = useVideoJSPlayerContext();

  // Handle timestamp param ?t=30 should seek to 30 seconds
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const timestamp = parseInt(urlParams.get('t'), 10);
    if (!timestamp) return;

    try {
      seekTo(timestamp);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }, []);

  return (
    <>
      {video?.videoStreams ? (
        <div className="events_player__inner">
          <div className="events_player__video_wrapper">
            <span className="beta-disclaimer">BETA</span>
            <div className="aspect-ratio">
              <div className="player_wrapper">
                <NewPlayer video={video} shareVideoUrl="fastcompany.com" />
              </div>
            </div>
            <div className="player_details">
              <div className="player_details__metadata">
                <Eyebrow
                  className="eyebrow"
                  text={getEyebrowFromTags(video?.internalTags)}
                />
              </div>
              <Title className="title" element="h1" text={video.title} xl />
              <DescriptionText
                className="description"
                text={video.description}
              />
            </div>
          </div>
          <>
            {video.captions && (
              <div className="transcript">
                <h2>Transcript</h2>
                <Transcriptions
                  propsCaptions={video.captions}
                  seekTo={seekTo}
                  currentTime={currentTime}
                  listWrapperClassName="transcriptions-list-wrapper"
                  timeBoxClassName="transcript-box"
                  textClassName="transcript-text"
                  listItemClassName="transcription-list-item"
                  listItemActiveStyles="background-color: #ccc"
                />
                <span className="beta-disclaimer">Generated by AWS</span>
              </div>
            )}
          </>
        </div>
      ) : (
        <p>No video found</p>
      )}
    </>
  );
};

export default VideoPlayer;
